<template>
	<v-row no-gutters>
		<v-col cols='3' align-self='center'>
			<v-img :src='lottery.logo.url' height='80' width='80' contain />
		</v-col>
		<v-col class='justify-center'>
			<sortition-result
				v-for='sortition in lottery.sortitions'
				class='sortition-result'
				:key='sortition.name'
				:sortition='sortition'
				:display-as-one="displayAsOne"
				:show-pick-five='showPickFive'
				no-gutters>
				<template v-if="$scopedSlots['sortition-header']" #header='data'>
					<slot name='sortition-header' v-bind='data'>
					</slot>
				</template>
			</sortition-result>
		</v-col>
	</v-row>
</template>

<script>
import SortitionResult from '@homepage/components/SortitionResult.vue';

export default {
	name: 'LotteryResult',
	components: { SortitionResult },
	props: {
		lottery: {
			type: Object,
			required: true
		},
		displayAsOne: {
			type: Boolean,
			default: true
		},
		showPickFive: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style scoped>
.sortition-result {
	padding: 3px 0;
}

.sortition-result:not(:last-child) {
	border-bottom: 3px solid black;
}
</style>
